import { render, staticRenderFns } from "./OrderDesc.vue?vue&type=template&id=17261e9d&scoped=true&"
import script from "./OrderDesc.vue?vue&type=script&lang=js&"
export * from "./OrderDesc.vue?vue&type=script&lang=js&"
import style0 from "./OrderDesc.vue?vue&type=style&index=0&id=17261e9d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17261e9d",
  null
  
)

export default component.exports